const airlineAnswerOptions = [
  { key: 0, text: 'Chartered', value: 'chartered' },
  { key: 1, text: 'Third partys fault', value: 'third_partys_fault' },
  { key: 2, text: 'Ticket sold by other airline', value: 'ticket_sold_by_other_airline' },
  { key: 3, text: 'Indirect disruption', value: 'indirect_disruption' },
  { key: 4, text: 'Technical operational issue', value: 'technical_operational_issue' },
  { key: 5, text: 'Lightning strike', value: 'lightning_strike' },
  { key: 6, text: 'Pax arrived on time', value: 'pax_arrived_on_time' },
  { key: 7, text: 'Pax eligible to 50 percent', value: 'pax_eligible_to_50_percent' },
  { key: 8, text: 'Pax already refunded', value: 'pax_already_refunded' },
  { key: 9, text: 'Entire trip', value: 'entire_trip' },
  { key: 10, text: 'Internal strike', value: 'internal_strike' },
  { key: 11, text: 'Operating carrier', value: 'operating_carrier' },
  { key: 12, text: 'Scope of regulation', value: 'scope_of_regulation' },
  { key: 13, text: 'Statute of limitation', value: 'statute_of_limitation' },
  { key: 14, text: 'Traffic controller strike', value: 'traffic_controller_strike' },
  { key: 15, text: 'Weather', value: 'weather' },
  { key: 16, text: 'Due to our intervention', value: 'due_to_our_intervention' },
  { key: 17, text: 'No answer', value: 'no_answer' }
]

export default airlineAnswerOptions;



// WEBPACK FOOTER //
// ./src/options/airlineAnswerOptions.js